import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { Getstates } from '../../../../Axios/ServiceApi';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  // Checkbox,
  // Divider,
  FormControl,
  // FormControlLabel,
  FormHelperText,
  Grid,

  // InputAdornment,
  InputLabel,
  OutlinedInput,

  // TextField,
  // Typography,
  // useMediaQuery
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
// import Upload from 'assets/images/Image upload-bro.svg';
// import Google from 'assets/images/icons/social-google.svg';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { Stack } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { GetBankDetails, GetIfscDetails, postBankDepositData } from '../../../../Axios/LimitAccountRegistration';
import { getProfileDetailsOnce } from '../../../../Axios/Profile';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormLabel from '@mui/material/FormLabel';
// import { IconUserPlus } from '@tabler/icons';
// import { Image } from '@mui/icons-material';
// import { strengthColor, strengthIndicator } from 'utils/password-strength';

// assets
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const CashDeposit = (props) => {
  const theme = useTheme();
  const scriptedRef = useScriptRef();




  const [stateList, setStateList] = useState(null)


  console.log('States ', stateList);



  const [BankList, setBankList] = useState(null)
  const [userDetails, setUserDetails] = useState(null)
  const [ifscData, setIfscData] = useState(null)


  useEffect(() => {
    Getstates(setStateList)
    GetBankDetails(setBankList)
    getProfileDetailsOnce(setUserDetails)
  }, [])

  console.log(userDetails);


  const handleIfscCheck=(ifsc,setFieldValue,validateForm)=>{
    GetIfscDetails(ifsc,setIfscData,setFieldValue,validateForm)
  }

  console.log("ifsc data", ifscData);


  return (
    <>



      {/*  */}

      {/*  */}
      {
        userDetails ?

          <Formik

            initialValues={{
              agent_code: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : '',
              agent_name: userDetails.first_name && userDetails.last_name ? userDetails.first_name + " " + userDetails.last_name : '',
              bank_name: "",
              bank_branch: "",
              branch_code: "",
              state: userDetails.retail_state ? userDetails.retail_state : "",
              district: userDetails.retail_district ? userDetails.retail_district : "",
              ifsc_code: ""
              // submit: null
            }}
            validationSchema={
              Yup.object().shape({
                agent_name: Yup.string().max(255).required('Name is required'),
                bank_branch: Yup.string().required("Bank Branch is required"),
                branch_code: Yup.string().required("Branch code is required"),
                agent_code: Yup.string().required('Agent Code is required'),
                bank_name: Yup.string().required('Bank Name is required'),
                state: Yup.string().required("State is required"),
                district: Yup.string().required("District is required"),
                ifsc_code: Yup.string().required("IFSC Code is required")
              })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
              try {
                if (scriptedRef.current) {
                  // AgentAddress(props.Postdata, props.file, Navigate,handleErrOpen);
                }
              } catch (err) {
                console.error('error ', err);
                if (scriptedRef.current) {
                  setStatus({ success: false });
                  setErrors({ submit: err.message });
                  setSubmitting(false);
                }
              }
            }}
          >

            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, isValid,setFieldValue ,validateForm}) => (
              <form noValidate onSubmit={handleSubmit}>

                <Stack direction={{ xs: 'column', xl: 'row', lg: 'row', md: 'row', sm: 'row' }}>
                  {/* <MapModal change={change} setChange={setChange} open={open} handleClose={handleClose} /> */}
                  <Grid item xs={12} sm={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.agent_code && errors.agent_code)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-pincode-register">Agent Code</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-pincode-register"
                            type="text"
                            value={values.agent_code}
                            name="agent_code"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            inputProps={{readOnly:true}}
                          />
                          {touched.agent_code && errors.agent_code && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.agent_code}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.agent_name && errors.agent_name)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-pincode-register">Agent Name</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-pincode-register"
                            type="text"
                            value={values.agent_name}
                            name="agent_name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            inputProps={{readOnly:values.agent_name!==''?true:false}}
                          />
                          {touched.agent_name && errors.agent_name && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.agent_name}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>


                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.ifsc && errors.ifsc)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-pincode-register">IFSC Code</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-pincode-register"
                            type="text"
                            value={values.ifsc_code}
                            name="ifsc_code"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            inputProps={{}}
                            endAdornment={
                              <Button
                                component="label"
                                sx={{ backgroundColor: '#A556B2', '&:hover': { backgroundColor: '#A556B2' } }}
                                variant="contained"
                                onClick={values.ifsc_code?()=>handleIfscCheck(values.ifsc_code,setFieldValue,validateForm):null}
                              >
                                Check
                              </Button>
                            }
                          />
                          {touched.ifsc_code && errors.ifsc_code && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.ifsc_code}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.bank && errors.bank)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-pincode-register">Bank Name</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={values.bank_name}
                            label="Bank Name"
                            name='bank_name'
                            sx={{ padding: '5px' }}
                            onChange={handleChange}
                          >
                            {
                              BankList && BankList.map((item, index) => {
                                return (
                                  <MenuItem value={item} key={index}>{item}</MenuItem>
                                )
                              })
                            }

                          </Select>
                          {touched.bank_name && errors.bank_name && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.bank_name}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.bank_branch && errors.bank_branch)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-pincode-register">Bank Branch Name</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-pincode-register"
                            type="text"
                            value={values.bank_branch}
                            name="bank_branch"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            inputProps={{}}
                          />
                          {touched.bank_branch && errors.bank_branch && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.bank_branch}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.state && errors.state)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel id="demo-simple-select-label">State</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="outlined-simple-select"
                            disabled
                            value={values.state}
                            label="State"
                            name='state'
                            onChange={handleChange}
                            sx={{ padding: 0.7 }}
                          >
                            {
                              stateList && Object.keys(stateList).map((item) => (

                                <MenuItem key={item} value={item}>{item}</MenuItem>
                              ))
                            }
                          </Select>
                          {touched.state && errors.state && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.state}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.district && errors.district)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel id="demo-simple-select-label">Bank District</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="outlined-simple-select"
                            disabled
                            value={values.district}
                            label="Bank District"
                            name='district'
                            onChange={handleChange}
                            sx={{ padding: 0.7 }}
                          >
                            {
                              stateList && Array.isArray(stateList[values.state]) && stateList[values.state].map((item) => (

                                <MenuItem key={item} value={item}>{item}</MenuItem>
                              ))
                            }
                          </Select>
                          {touched.district && errors.district && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.district}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6} md={6} sm={6}>
                        <FormControl fullWidth error={Boolean(touched.branch_code && errors.branch_code)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-pincode-register">Branch Code</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-pincode-register"
                            type="text"
                            value={values.branch_code}
                            name="branch_code"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            inputProps={{}}
                          />
                          {touched.branch_code && errors.branch_code && (
                            <FormHelperText error id="standard-weight-helper-text-pincode-register">
                              {errors.branch_code}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                    </Grid>


                    {errors.submit && (
                      <Box sx={{ mt: 3 }}>
                        <FormHelperText error>{errors.submit}</FormHelperText>
                      </Box>
                    )}
                  </Grid>
                </Stack>
                <Grid container spacing={4}>
                  <Grid item sm={6} xs={6}>
                    <Box sx={{ mt: 2 }}>
                      <AnimateButton>
                        <Button
                          disableElevation
                          disabled={isSubmitting || !isValid}
                          fullWidth
                          size="large"
                          variant="contained"
                          sx={{ backgroundColor: '#A556B2', color: '#fff', "&:hover": { backgroundColor: "#A556B2" } }}
                          onClick={!isSubmitting && isValid?()=>postBankDepositData(values, props.setAlertMessage, props.setErrOpen, props.setAlertType, props.setOpenLoader,setFieldValue):null}
                        >
                          {console.log(errors)}
                          Submit
                        </Button>
                      </AnimateButton>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
          :
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
      }

      {/* image upload Dialog start */}
    </>
  );
};

export default CashDeposit;
